<div
  class="bg-[#f0f1f2] h-full z-[1] rounded-[24px] grid place-content-between place-items-center w-[220px]">
  <div class="grid place-items-start h-[34px] mt-8 p-1">
    <div>
      <h2 class="font-bold grid text-3xl ml-2">WriteMed.AI</h2>
    </div>
    <div class="w-full mt-4">
      <mat-nav-list>
        @for (nav of navData; track nav) {
          @if (!nav.items || nav.items.length === 0) {
            <a
              class="w-full flex my-2 no-underline rounded-[0.625rem] cursor-pointer transition-all sidenav-nav-link text-sm hover:bg-primary text-black hover:text-[#fff]"
              mat-list-item
              [routerLink]="[nav.routeLink]"
              routerLinkActive="active"
              #rla="routerLinkActive"
              [activated]="rla.isActive"
              [tourAnchor]="nav.label">
              <mat-icon
                matListItemIcon
                [fontIcon]="nav.icon ?? 'empty'"></mat-icon>
              <span matListItemTitle class="hover:text-white">{{
                nav.label | titlecase
              }}</span>
            </a>
          } @else {
            <div class="menu-trigger-wrapper">
              <button
                mat-button
                (click)="toggleSubmenu(nav)"
                class="w-full flex flex-row-reverse my-2 no-underline rounded-[0.625rem] cursor-pointer transition-all sidenav-nav-link text-sm hover:bg-primary text-black hover:text-[#fff] p-3">
                <span class="mr-2 text-black">{{ nav.label | titlecase }}</span>

                <mat-icon
                  class="ml-2 transition-transform"
                  [class.rotate-180]="nav.isExpanded"
                  >expand_more</mat-icon
                >
              </button>

              <div
                class="submenu bg-[#f0f1f2] rounded-lg overflow-hidden transition-all"
                [class.h-0]="!nav.isExpanded"
                [class.h-auto]="nav.isExpanded">
                @for (subItem of nav.items; track subItem) {
                  <a
                    class="pl-8 w-full my-2 flex no-underline rounded-full cursor-pointer transition-all sidenav-nav-link text-sm hover:bg-primary text-black hover:text-[#fff] p-3"
                    [routerLink]="[subItem.routeLink]"
                    routerLinkActive="active"
                    #rla="routerLinkActive">
                    <mat-icon [fontIcon]="subItem.icon ?? 'empty'"></mat-icon>
                    <span class="ml-2">{{ subItem.label | titlecase }}</span>
                  </a>
                }
              </div>
            </div>
          }
        }
      </mat-nav-list>
    </div>
  </div>

  <div class="wrapper w-full mb-8">
    <!-- <mat-nav-list>
      <a
        mat-list-item
        class="gap-3 no-underline rounded-[0.625rem] cursor-pointer transition-all p-2 sidenav-nav-link hover:bg-primary text-black hover:text-[#fff]"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        (click)="logout()"
        tourAnchor="Logout"
        [attr.aria-hidden]="true">
        <mat-icon matListItemIcon>logout</mat-icon>
        <span matListItemTitle class="hover:text-white">{{
          'logout' | titlecase
        }}</span>
      </a>
    </mat-nav-list> -->

    <!-- <p
      class="gap-3 no-underline rounded-[0.625rem] cursor-pointer transition-all p-2 sidenav-nav-link hover:bg-primary text-black hover:text-[#fff]"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="logout()"
      tourAnchor="Logout"
      [attr.aria-hidden]="true">
      <i class="fa-solid fa-arrow-right-from-bracket"></i>
      <span class="mx-2" *ngIf="!collapsed">Logout</span>
    </p> -->
  </div>
</div>
<tour-step-template></tour-step-template>
